export interface PKGLayoutPosition {
  x: number;
  y: number;
}

export type PKGLayoutPositions = Map<string, PKGLayoutPosition>;

/** Card footprint used by layout helpers that need node dimensions (dagre). */
export const LAYOUT_NODE_WIDTH = 180;
export const LAYOUT_NODE_HEIGHT = 64;
